export interface EstadosPyLPagingRes {
  count: number;
  next?: string;
  previous?: string;
  numero_paginas: number;
  data: EstadoPyL[];
}

export interface EstadoPyL {
  id_estado_pil?: number;
  nombre: string;
  codigo: string;
}

export enum EstadoPyLCodigoEnum { // agenda
  ESPERA = 1, // espera
  APROBADO = 2, // agendado
  RECHAZADO = 3, // rechazado
  ESPERA_REAGENDAR = 4, // espera reagendado - vendedor setea al actualizar agenda
  REAGENDADO = 5, // reagendado - pyl setea

  // activacion:
  ESPERA_RECOORDINACION = 6, // OW recoordinada by activacion
  RECOORDINADO = 7, // pyl ok a 1 recoordinada

  // OT
  ESPERA_CIERRE = 8,
  CERRADO = 9,
}

///* NEW: PREAGENDA / AGENDA ======================================
export enum EstadosPreagendamientoCodigoEnum {
  ESPERA = 'EN ESPERA',
  PENDIENTE_PAGO = 'PENDIENTE_PAGO',
  PENDIENTE_REAGENDAR = 'PENDIENTE_REAGENDAR',

  APROBADO = 'APROBADO',
  REAGENDADO = 'REAGENDADO',
  RECHAZADO = 'RECHAZADO',
  FINALIZADO = 'FINALIZADO',
  PAUSADO = 'PAUSADO',
}

export enum EstadosPreagendamientoPagoEnum {
  PENDIENTE = 'PENDIENTE',
  PAGADO = 'PAGADO',
  PAGADO_DEBITO = 'PAGADO DÉBITO',
}
export enum EstadosAgendamientoCodigoEnum {
  APROBADO = 'APROBADO',
  REAGENDADO = 'REAGENDADO',

  RECOORDINADO = 'RECOORDINADO', // reject OT activacion
  PENDIENTE_RECOORDINACION = 'PENDIENTE_RECOORDINACION', // reject OT activacion
}
